<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <section>
      <fieldset class="tw-py-30px">
        <legend>{{ "common.organizationList" | translate }}</legend>

        <div class="row">
          <!-- organizationId -->
          <div class="md:tw-w-full">
            <organization-selection-list
              type="descendantList"
              searchLabel="messages.searchInOrganizations"
              [values]="organizationIds"
              [isDisableSelectedItem]="true"
              (values)="organizationIds = $event"
            >
            </organization-selection-list>
          </div>
        </div>
      </fieldset>
    </section>

    <!-- form btns-->
    <section class="tw-my-15px">
      <div class="tw-flex tw-justify-end tw-my-5">
        <div class="tw-flex tw-justify-end">
          <!-- cancel -->
          <a
            mat-ripple
            class="btn tw-mx-[5px] button-shadow"
            [themeColor]="'cancel-btn'"
            (click)="onClose()"
            >{{ "common.cancel" | translate }}</a
          >
          <!-- submit -->
          <button
            mat-ripple
            class="btn tw-w-[125px] tw-mx-[5px] button-shadow btn-hover-rise"
            [themeColor]="'btn'"
            [disabled]="loading"
            (click)="onSubmit()"
          >
            <ng-container *ngIf="!loading">
              <span *ngIf="!formPageConfig.isEditMode">{{
                "common.submit" | translate
              }}</span>
            </ng-container>

            <ng-container *ngIf="loading">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Loading...</span>
            </ng-container>
          </button>
        </div>
      </div>
    </section>
  </div>
</app-page-body>
